import { Share2, Eye } from "lucide-react"
import { ShareableCardModal } from "~/components/ShareableCardModal"
import type { DogPortraitInfo } from "~/api/auth"
import { useShareCardSession } from "~/hooks/useShareCardSession"

type DashboardSharePanelProps = {
  dogName: string
  archetypeLabel: string
  assessmentSessionToken?: string | null
  archetypeIcon?: string | null
  portrait?: DogPortraitInfo | null
}

export function DashboardSharePanel({
  dogName,
  archetypeLabel,
  assessmentSessionToken,
  archetypeIcon,
  portrait,
}: DashboardSharePanelProps) {
  const {
    session,
    modalOpen,
    openShareModal,
    closeShareModal,
    personalizedPortraitUrl,
    canShare,
    loading,
  } = useShareCardSession({
    assessmentSessionToken,
    archetypeIcon,
    portrait,
  })

  return (
    <section
      data-testid="dashboard-share-panel"
      className="mt-4 rounded-xl border border-[var(--color-divider)] bg-[var(--color-bg-primary)] p-4 text-center"
    >
      <h2 className="text-lg font-semibold text-[var(--color-text-primary)]">
        Share {dogName}&apos;s personality
      </h2>
      <p className="mt-1 text-sm text-[var(--color-text-secondary)]">
        Let friends meet {dogName}, {archetypeLabel}.
      </p>
      <div className="mt-3 flex flex-wrap items-center justify-center gap-2">
        <button
          type="button"
          onClick={openShareModal}
          disabled={!canShare || loading}
          className="inline-flex items-center gap-2 rounded-lg bg-[var(--color-text-primary)] px-4 py-2 text-sm font-medium text-[var(--color-surface-card)] transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <Share2 size={15} aria-hidden />
          Share card
        </button>
        <button
          type="button"
          onClick={openShareModal}
          disabled={!canShare || loading}
          className="inline-flex items-center gap-2 rounded-lg border border-[var(--color-divider)] bg-[var(--color-surface-card)] px-4 py-2 text-sm font-medium text-[var(--color-text-primary)] transition hover:opacity-90 disabled:cursor-not-allowed disabled:opacity-60"
        >
          <Eye size={15} aria-hidden />
          Preview
        </button>
      </div>

      {session && (
        <ShareableCardModal
          isOpen={modalOpen}
          onClose={closeShareModal}
          data={session}
          personalizedPortraitUrl={personalizedPortraitUrl}
        />
      )}
    </section>
  )
}
